import { Component } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { NotificationService } from "../../services/notification.service";

@Component({
  selector: 'page-xp-notifications',
  templateUrl: 'xp-notifications.html',
})
export class XpNotificationsPage {

  public data = [];

  constructor(
    public service: NotificationService,
    public alertCtrl: AlertController
  ) {
  }

  public openNotification(notification){
    this.alertCtrl.create({
      title: notification.list_title,
      message: notification.list_subtitle,
      buttons: ['OK']
    }).present();
  }

  public ionViewDidEnter() {
    console.log('ionViewDidLoad XpNotificationsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-notifications/xp-notifications.ts